import './index.css';
import './locale';
import { configureApp } from './configure';
import { run } from './App';

configureApp();
run();
